<template>
  <div id="create-contact-form">
    <Spin fix v-if="loading"></Spin>
    <Form ref="contactDataForm" :model="formData">
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('contact.firstname')" label-position="top" prop="firstname" required>
            <Input
            type="text"
            v-model="formData.firstname"
            :placeholder="$t('contact.firstname_placeholder')"/>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('contact.lastname')" label-position="top" prop="lastname" required>
            <Input
            type="text"
            v-model="formData.lastname"
            :placeholder="$t('contact.lastname_placeholder')"
          />
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('contact.email')" label-position="top" prop="email" required>
            <Input
            type="text"
            v-model="formData.email"
            :placeholder="$t('contact.email_placeholder')"
          />
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('contact.phone')" label-position="top" prop="contact_phone" required>
            <Input
            type="text"
            v-model="formData.contact_phone"
            :placeholder="$t('contact.contact_phone_placeholder')"
          />
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('contact.alias')" label-position="top" prop="alias">
            <Input
            type="text"
            v-model="formData.alias"
            :placeholder="$t('contact.alias_placeholder')"
          />
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('contact.status')" label-position="top" prop="status" required>
            <ContactStatusSelect v-model="formData.status"></ContactStatusSelect>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('contact.description')" label-position="top" prop="description">
            <Input
            type="text"
            v-model="formData.description"
            :placeholder="$t('contact.description_placeholder')"
          />
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('contact.address')" label-position="top" prop="address">
            <Input
            type="text"
            v-model="formData.address"
            :placeholder="$t('contact.address_placeholder')"
          />
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('contact.city')" label-position="top" prop="city">
            <Input
            type="text"
            v-model="formData.city"
            :placeholder="$t('contact.city_placeholder')"
          />
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('contact.state')" label-position="top" prop="state">
            <Input
            type="text"
            v-model="formData.state"
            :placeholder="$t('contact.state_placeholder')"
          />
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('contact.postal_code')" label-position="top" prop="postal_code">
            <Input
            type="text"
            v-model="formData.postal_code"
            :placeholder="$t('contact.postal_code_placeholder')"
          />
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('contact.country')" label-position="top" prop="country">
            <CountrySelect v-model="formData.country_code" @countryData="setCountryData"></CountrySelect>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('contact.tags')" label-position="top" prop="tags" required>
            <CheckboxGroup v-model="formData.tags" >
              <Checkbox label="Client" border></Checkbox>
              <Checkbox label="Supplier" border></Checkbox>
            </CheckboxGroup>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div class="contact-edit-drawer-footer text-align-right">
      <Button type="primary" @click="handleSubmit(formData)" :loading="saving">{{ $t('form.save') }}</Button>
    </div>
  </div>
</template>

<script>
import { ContactStatusSelect } from '../form-controls'
import { CountrySelect } from '@/components/nexpcb'

export default {
  name: 'ContactForm',
  components: {
    ContactStatusSelect,
    CountrySelect
  },
  props: {
    contact: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saving: false,
      adding: true,
      formData: {
        firstname: '',
        lastname: '',
        email: '',
        contact_phone: '',
        status: '',
        alias: '',
        job_title: '',
        description: '',
        country: '',
        tags: []
      }
    }
  },
  mounted () {
  },
  methods: {
    handleSubmit (contact) {
      this.$refs['contactDataForm'].validate((valid) => {
        if (valid) {
          this.$emit("save-contact", contact)
        }
      })
    },
    setCountryData(countryData) {
      this.formData.country_code = countryData.code
      this.formData.country = countryData.name
    }
  },
  watch: {
    loading: function () {
      this.formData = Object.assign({}, this.formData, this.contact)
    }
  }
}

</script>
